module.exports = __webpack_public_path__ + "img/topicMobility.39a5e693.png";